import { forwardRef, type InputHTMLAttributes, useId } from "react";

import { cn } from "./lib/cn";

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, className, id, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label
      htmlFor={inputId}
      className={cn("inline-flex items-center gap-2 text-sm text-slate-700", className)}
    >
      <input ref={ref} id={inputId} type="radio" className="size-4 accent-primary" {...rest} />
      {label}
    </label>
  );
});
